import type { Insurance } from "@/types/insurance/insurance";

export const DEFAULT_COMPENSATION_TAPER_START_AGE = 46;

/** S: age at which tapering begins (full payout for age <= S). */
export const getCompensationTaperStartAge = (
	insurance: Insurance | undefined,
): number => {
	const raw = parseFloat(
		insurance?.params?.find(
			(param) => param.type === "compensation-taper-start-age",
		)?.value as string,
	);
	return !Number.isNaN(raw) && raw >= 1
		? Math.floor(raw)
		: DEFAULT_COMPENSATION_TAPER_START_AGE;
};
